export enum PaymentMethod {
    Card = 'card',
    Installments3 = 'installments3',
    Installments4 = 'installments4',
    Installments6 = 'installments6',
    Installments10 = 'installments10',
    Installments12 = 'installments12',
    Dolyame = 'dolyame',
}
